module.exports = __webpack_public_path__ + "img/processing.6a80f88b.svg";